// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2s5QD","image":"Header_image__2j3O8","name":"Header_name__dUu8h","info":"Header_info__2Hwpp","infoRow":"Header_infoRow__2gYJk"};